const defaultEvents = [
  {
    selector: '.header__card-phones-items .header__card-phones-item',
    hasMultipleElements: true,
    eventName: 'click_phone',
    hasLocalByDOM: true,
    normalizer: 'normalizeContactLocal',
  },
  {
    selector: '.header__card-phones-items .header__card-whatsapp-item',
    hasMultipleElements: true,
    eventName: 'click_whatsapp',
    hasLocalByDOM: true,
    normalizer: 'normalizeContactLocal',
  },
  {
    selector: '.showcase-simple .slide__image',
    hasMultipleElements: true,
    eventName: 'click_banner',
    hasLocalByDOM: true,
    normalizer: 'normalizeBannerName',
  },
  {
    selector: '.channel-pop-up__image',
    hasMultipleElements: false,
    eventName: 'click_popup_home',
    hasLocalByDOM: false,
    normalizer: null,
  },
  {
    selector: '.floating-whatsapp__button',
    hasMultipleElements: false,
    eventName: 'flutuante',
    hasLocalByDOM: false,
    normalizer: null,
  },
  {
    selector: '.whatsapp-box .whatsapp-box__button',
    hasMultipleElements: false,
    eventName: 'click_whatsapp_box',
    hasLocalByDOM: false,
    normalizer: null,
  },
];

const indexEvents = [
  {
    selector: '.page--home .vehicles-new__button-whatsapp',
    hasMultipleElements: false,
    eventName: 'click_whatsapp_carrossel_novos',
    hasLocalByDOM: false,
    normalizer: null,
  },
  {
    selector: '.page--home .carousel-offers-vehicles-new__button-whatsapp',
    hasMultipleElements: false,
    eventName: 'click_whatsapp_carrossel_ofertas',
    hasLocalByDOM: false,
    normalizer: null,
  },
];

const newVehicleShowEvents = [
  {
    selector: '.showcase-new-cars__whatsapp-button',
    hasMultipleElements: false,
    eventName: 'click_whatsapp_interna_novos',
    hasLocalByDOM: false,
    normalizer: null,
  },
  {
    selector: '.vehicle-details-whatsapp__button',
    hasMultipleElements: false,
    eventName: 'click_whatsapp_interna_novos',
    hasLocalByDOM: false,
    normalizer: null,
  },
];

const offerShowEvents = [
  {
    selector: '.page--offer .showcase-whatsapp-box__button',
    hasMultipleElements: false,
    eventName: 'click_whatsapp_interna_ofertas',
    hasLocalByDOM: false,
    normalizer: null,
  },
  {
    selector: '.page--offer .gallery_whatsapp-box__button',
    hasMultipleElements: false,
    eventName: 'click_whatsapp_interna_ofertas',
    hasLocalByDOM: false,
    normalizer: null,
  },
  {
    selector: '.page--offer .vehicle_details_whatsapp-box__button',
    hasMultipleElements: false,
    eventName: 'click_whatsapp_interna_ofertas',
    hasLocalByDOM: false,
    normalizer: null,
  },
  {
    selector: '.page--national-offers .button--whatsapp',
    hasMultipleElements: false,
    eventName: 'click_whatsapp_interna_ofertas',
    hasLocalByDOM: false,
    normalizer: null,
  },
  {
    selector: '.showcase-exclusive-offer .button--whatsapp',
    hasMultipleElements: false,
    eventName: 'click_whatsapp_interna_ofertas',
    hasLocalByDOM: false,
    normalizer: null,
  },
];

const usedModelShowEvents = [
  {
    selector: '#used-vehicles__cta-box-button',
    hasMultipleElements: false,
    eventName: 'click_whatsapp_interna_seminovos',
    hasLocalByDOM: false,
    normalizer: null,
  },
  {
    selector: '#used-vehicles__cta-box-button-mobile',
    hasMultipleElements: false,
    eventName: 'click_whatsapp_interna_seminovos',
    hasLocalByDOM: false,
    normalizer: null,
  },
];

export {
  defaultEvents,
  indexEvents,
  newVehicleShowEvents,
  offerShowEvents,
  usedModelShowEvents,
};
